import React from "react"
import { cx, css } from "emotion"
import { withTheme } from "emotion-theming"

class Icon extends React.Component {
    render() {
        let style = css`
            margin: 0px ${this.props.theme[this.props.margin || "small"]};
        `

        let weightIndicator = ""
        if (this.props.weight === "heavy") weightIndicator = ""
        if (this.props.weight === "regular") weightIndicator = "r"
        if (this.props.weight === "light") weightIndicator = "l"
        let className = cx(
            `fa${weightIndicator} fa-${this.props.icon}`,
            style,
            this.props.className
        )
        return <i {...this.props} className={className} />
    }
}
export default withTheme(Icon)



// WEBPACK FOOTER //
// ./src/ui/components/Icon.js